<div class="w-full h-full">
    <app-tab-header [tabs]="tabs">
        <app-print-button 
            matTooltip="Not yet functional"
        >
        </app-print-button>
    </app-tab-header>
    
    <div class="px-8">
        <app-toggle-add-btn
            label="Add Biller"
            icon="add_circle"
            permission="megapay.skusBillers.payBills.edit"
            (clicked)="toggleDisplay()"
        />
        
        <form [hidden]="isDisplay" [formGroup]="payBillsForm">
            <div class="grid grid-cols-12 gap-1 mt-6">
                <!-- Biller Name -->
                <div class="col-span-3 mb-3">
                    <div [appHighlightOnActive]="" class="card-input flex items-center text-xs py-2 w-full">
                        <span class="text-xs w-110-px font-semibold">
                            Biller Name:
                        </span>
                        <input class="placeholder-black focus:outline-none w-full h-30-px bg-gray-100 rounded-md pl-3 italic" 
                            formControlName="billerName" 
                            type="text" 
                            placeholder="Biller Name">
                    </div>
                </div>
                
                <!-- Biller Description -->
                <div class="col-span-3 mb-3">
                    <div [appHighlightOnActive]="" class="card-input flex items-center text-xs py-2 w-full">
                        <div class="text-xs w-160-px font-semibold">
                            Biller Description:
                        </div>
                        <input class="placeholder-black focus:outline-none w-full h-30-px bg-gray-100 rounded-md pl-3 italic" 
                            formControlName="billerDescription" 
                            type="text" 
                            placeholder="Enter Description">
                    </div>
                </div>
                
                <!-- Biller Category -->
                <div class="col-span-3 mb-3">
                    <div [appHighlightOnActive]="" class="card-input flex items-center text-xs py-2 w-full">
                        <span class="text-xs w-90-px font-semibold">
                            Biller Category:
                        </span>
                        <app-dropdown-field
                            [options]="billerCategoryOptions"
                            [selectedText]="billerCategory_text"
                            placeholder="== Select an option =="
                            (selectionChange)="setBillerCategory($event.label, $event.value)"
                        ></app-dropdown-field>
                    </div>
                </div>

                <!-- Biller Image -->
                <div class="col-span-3 mb-3">
                    <div [appHighlightOnActive]="" class="card-input flex items-center justify-between text-xs py-2 w-full">
                        <div class="text-xs w-90-px font-semibold">
                            Biller Image:
                        </div>
                        <div class="flex flex-row gap-1">
                            <input formControlName="image" 
                                type='file' 
                                class="hidden" 
                                (change)="onSelectFile($event)" 
                                #coverImg 
                                accept="image/*">
                            
                            <button type="button" 
                                    class="flex items-center justify-center uppercase custom-btn font-semibold h-30-px px-3 py-1 focus:outline-none" 
                                    [ngClass]="imageFile? 'bg-white b-orange orange-text font-bold' : 'btn-dark-orange'"
                                    (click)="coverImg.click()">
                                <span *ngIf="imageFile" class="material-icons orange-text text-sm mr-2">
                                    upload
                                </span>
                                {{ !imageFile ? 'Upload' : 'Reupload' }}
                            </button>
                            
                            <button type="button" 
                                    *ngIf="imageFile" 
                                    class="flex items-center justify-center uppercase btn-dark-orange custom-btn font-semibold h-30-px px-3 py-1 focus:outline-none" 
                                    (click)="viewUploadedImage()">
                                View
                                <span class="material-icons text-white text-sm ml-2">
                                    visibility
                                </span>
                            </button>
                        </div>
                    </div>
                </div>

                <!-- First Field Name & Second Field Name -->
                <div class="col-span-4">
                    <div [appHighlightOnActive]="" class="card-input flex items-center text-xs py-2 w-full mb-3">
                        <span class="text-xs w-190-px font-semibold">
                            First Field Name:
                        </span>
                        <input class="placeholder-black focus:outline-none w-full h-30-px bg-gray-100 rounded-md pl-3 italic" 
                            formControlName="firstFieldName" 
                            type="text" 
                            placeholder="First Field Name">
                    </div>
                    <div [appHighlightOnActive]="" class="card-input flex items-center text-xs py-2 w-full mt-6">
                        <span class="text-xs w-190-px font-semibold">
                            Second Field Name:
                        </span>
                        <input class="placeholder-black focus:outline-none w-full h-30-px bg-gray-100 rounded-md pl-3 italic" 
                            formControlName="secondFieldName" 
                            type="text" 
                            placeholder="Second Field Name">
                    </div>
                </div>

                <!-- First Field Format & Second Field Format -->
                <div class="col-span-4 mb-3">
                    <div [appHighlightOnActive]="" class="card-input flex items-center text-xs py-2 w-full">
                        <div class="flex items-center space-x-3">
                            <span class="text-xs w-100-px font-semibold">
                                First Field Format:
                            </span>
                            <app-dropdown-field
                                [options]="fieldFormatOptions"
                                [selectedText]="firstFieldFormat_text"
                                placeholder="== Select an option =="
                                (selectionChange)="setFirstFieldFormat($event.label, $event.value)"
                            ></app-dropdown-field>
                        </div>
                    </div>
                    <div [appHighlightOnActive]="" class="card-input flex items-center text-xs py-2 w-full mt-6">
                        <div class="flex items-center">
                            <span class="text-xs w-116-px font-semibold">
                                Second Field Format:
                            </span>
                            <app-dropdown-field
                                [options]="fieldFormatOptions"
                                [selectedText]="secondFieldFormat_text"
                                placeholder="== Select an option =="
                                (selectionChange)="setSecondFieldFormat($event.label, $event.value)"
                            ></app-dropdown-field>
                        </div>
                    </div>
                </div>

                <!-- First & Second Field Max Length -->
                <div class="col-span-4 mb-1">
                    <div [appHighlightOnActive]="" class="card-input flex items-center text-xs py-2 w-full">
                        <span class="text-xs w-300-px font-semibold">
                            First Field Max Length:
                        </span>
                        <input class="placeholder-black focus:outline-none w-full h-30-px bg-gray-100 rounded-md pl-3 italic" 
                            formControlName="firstFieldWidth" 
                            type="number"
                            appOnlyNumber
                            placeholder="Length">
                    </div>
                    <div [appHighlightOnActive]="" class="card-input flex items-center text-xs py-2 w-full mt-6">
                        <span class="text-xs w-300-px font-semibold">
                            Second Field Max Length:
                        </span>
                        <input class="placeholder-black focus:outline-none w-full h-30-px bg-gray-100 rounded-md pl-3 italic" 
                            formControlName="secondFieldWidth"  
                            type="number" 
                            appOnlyNumber
                            placeholder="Length">
                    </div>
                </div>

                <!-- Convenience Fee -->
                <div class="col-span-4">
                    <div [appHighlightOnActive]="" class="card-input flex items-center text-xs py-2 w-full">
                        <span class="text-xs w-140-px font-semibold">
                            Convenience Fee:
                        </span>
                        <input class="placeholder-black focus:outline-none w-full h-30-px bg-gray-100 rounded-md pl-3 italic" 
                            formControlName="convenienceFee" 
                            type="number" 
                            appOnlyNumber 
                            [allowDecimal]="true" 
                            placeholder="Convenience Fee">
                    </div>
                </div>

                <!-- Service Fee Percentage -->
                <div class="col-span-4">
                    <div [appHighlightOnActive]="" class="card-input flex items-center text-xs py-2 w-full">
                        <span class="text-xs w-280-px font-semibold">
                            Service Fee Percentage (%):
                        </span>
                        <input class="placeholder-black focus:outline-none w-full h-30-px bg-gray-100 rounded-md pl-3 italic" 
                            formControlName="serviceFeePercentage" 
                            type="number" 
                            appOnlyNumber 
                            [allowDecimal]="true" 
                            placeholder="Applied as percentage of the bill amount (0-100)">
                    </div>
                </div>

                <!-- Service Fee Fixed -->
                <div class="col-span-4">
                    <div [appHighlightOnActive]="" class="card-input flex items-center text-xs py-2 w-full">
                        <span class="text-xs w-170-px font-semibold">
                            Service Fee Fixed:
                        </span>
                        <input class="placeholder-black focus:outline-none w-full h-30-px bg-gray-100 rounded-md pl-3 italic" 
                            formControlName="serviceFeeFixed" 
                            type="number" 
                            appOnlyNumber 
                            [allowDecimal]="true" 
                            placeholder="Service Fee">
                    </div>
                </div>

                <!-- Submit Button -->
                <div class="col-span-12 mt-5">
                    <div class="w-full h-full flex items-end justify-center">
                        <button 
                            appDisableWithoutPermission="megapay.skusBillers.payBills.edit"
                            matTooltip
                            (click)="store()" 
                            [ngClass]="isSubmitDisabled() ? 'bg-gray-400 opacity-50' : 'btn-dark-orange'"
                            [disabled]="isSubmitDisabled()"
                            class="uppercase custom-btn font-semibold text-xs px-6 py-2 transition-all">
                            submit
                        </button>
                    </div>
                </div>
            </div>
        </form>
    </div>

    <!-- Search and Limit Controls -->
    <div class="bg-light-orange w-full flex items-center justify-between space-x-3 pr-3 pt-4 text-sm mt-10">
        <div class="flex items-center pl-6" [formGroup]="limitForm">
            <div class="orange-text text-xs">Show</div>
            <input class="orange-input focus:outline-none text-center mx-1 w-25-px text-xs p-1" 
                type="number" 
                formControlName="limit" 
                (change)="limitKey($event)" 
                value="{{size}}">
            <div class="orange-text text-xs">entries</div>
        </div>
        <div class="flex items-center space-x-3 pr-3" [formGroup]="searchForm" (keydown)="keyDownFunction($event)">
            <div class="orange-text text-xs">Search:</div>
            <input class="orange-input focus:outline-none pl-1 text-xs p-1" 
                type="text" 
                placeHolder="Search"  
                formControlName="search" 
                (keyup)="searchKey($event)">
        </div>
    </div>

    <!-- Data Table -->
    <app-data-table
        [tableHeader]="tableHeader"
        [tableSubHeader]="tableSubHeader"
        [isLoading]="isLoading"
        [sort_type]="sort_type"
        (toggleOnSort)="sortList($event.key, $event.type)"
    >
        <tr class="focus:outline-none" *ngFor="let paybills of paybills_lists">
            <td>{{paybills.billerName | nullWithDefault | titlecase}}</td>
            <td *ngIf="paybills.billerCategory">
                <p *ngIf="paybills.billerCategory===2">Telecom</p>
                <p *ngIf="paybills.billerCategory===3">Credit Card</p>
                <p *ngIf="paybills.billerCategory===4">Cable and Internet</p>
                <p *ngIf="paybills.billerCategory===5">Government</p>
                <p *ngIf="paybills.billerCategory===6">Loans</p>
                <p *ngIf="paybills.billerCategory===7">Others</p>
                <p *ngIf="paybills.billerCategory===8">Travel</p>
                <p *ngIf="paybills.billerCategory===9">Transpo</p>
                <p *ngIf="paybills.billerCategory===10">Shopping</p>
                <p *ngIf="paybills.billerCategory===11">Power</p>
                <p *ngIf="paybills.billerCategory===12">Water</p>
            </td>
            <td>{{paybills.billerDescription | nullWithDefault}}</td>
            <td>{{paybills.firstFieldName | nullWithDefault | titlecase}}</td>
            <td *ngIf="paybills.firstFieldFormat">
                <p *ngIf="paybills.firstFieldFormat===1">Numeric</p>
                <p *ngIf="paybills.firstFieldFormat===2">Alphanumeric</p>
            </td>
            <td>
                <p *ngIf="paybills.firstFieldWidth !== null">{{paybills.firstFieldWidth}}</p>
                <p *ngIf="paybills.firstFieldWidth === null">0</p>
            </td>
            <td>{{paybills.secondFieldName | nullWithDefault | titlecase}}</td>
            <td *ngIf="paybills.secondFieldFormat">
                <p *ngIf="paybills.secondFieldFormat===1">Numeric</p>
                <p *ngIf="paybills.secondFieldFormat===2">Alphanumeric</p>
            </td>
            <td>
                <p *ngIf="paybills.secondFieldWidth !== null">{{paybills.secondFieldWidth}}</p>
                <p *ngIf="paybills.secondFieldWidth === null">0</p>
            </td>
            <td>{{ paybills.convenienceFee / 100 | number:'1.2-2'}}</td>
            <td>
                {{ (paybills.serviceFeePercentage || 0) | number:'1.0-2' }}%
            </td>
            <td>
                {{ paybills.serviceFeeFixed }}
            </td> 
            <td>
                <p *ngIf="paybills.status===0">Active</p>
                <p *ngIf="paybills.status!==0">Inactive</p>
            </td>
            <td>
                <p *ngIf="paybills.hasLimit===0">Yes</p>
                <p *ngIf="paybills.hasLimit!==0">No</p>
            </td>
            <td class="flex-items-center">
                <a *ngIf="paybills.imageUrl" class="link" (click)="openSite(paybills.imageUrl)">Link</a>
                <a *ngIf="!paybills.imageUrl">N/A</a>
            </td>
            <td class="text-xs">
                <div class="flex items-center space-x-3">
                    <ng-container *ngIf="paybills" class="pl-2">
                        <button appDisableWithoutPermission="megapay.skusBillers.payBills.edit" matTooltip class="power-btn2 active" *ngIf="paybills.status===0" (click)="disable(paybills.uid, 1)">
                            Enabled
                        </button>
                        <button appDisableWithoutPermission="megapay.skusBillers.payBills.edit" matTooltip class="power-btn2" *ngIf="paybills.status===1" (click)="enable(paybills.uid, 0)">
                            Disabled
                        </button>
                    </ng-container>
                    <button appDisableWithoutPermission="megapay.skusBillers.payBills.edit" matTooltip class="action-btn-blue2 custom-btn" [routerLink]="['/features/biller-dashboard/sku-pay-bills/sku-paybills-edit/'+ paybills.billerName]">
                        Edit
                    </button>
                </div>
            </td>
        </tr>
    </app-data-table>

    <!-- Pagination -->
    <app-pagination
        [currentPage]="current_page"
        [totalPages]="total_pages"
        [pageSize]="size"
        [totalItems]="total"
        (pageChange)="setPage($event)"
        (previousPage)="prevPage()"
        (nextPage)="nextPage()"
        showTotalEntries="true"
    ></app-pagination>
</div>

<ngx-spinner type="border" size="medium">
    <app-megapay-loader></app-megapay-loader>
</ngx-spinner>